import type { DefaultColorScheme } from "@codegouvfr/react-dsfr/next-app-router"

export const defaultColorScheme: DefaultColorScheme = "light"
